import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const styContainerCardMF = css`
  box-sizing: border-box;
  margin-top: 24px;
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 12px;

  width: 580px;
  height: 64px;
  background: ${colors.NEUTRAL_0};

  border: 1px solid ${colors.NEUTRAL_2};
  border-radius: 12px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  justify-content: space-between;
`;

export const styContainerMF = css`
  margin-bottom: 10px;
`;
export const styModal = css`
  justify-content: left !important;
  display: block;
  text-justify: left !important;
  justify-items: left !important;
  justify-self: left !important;
  text-align: left !important;
`;

export const styTopTextCard = css`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: ${colors.NEUTRAL_7};
`;

export const styBottomTextCard = css`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.NEUTRAL_};
`;
